export const ACTIVITY_MAX_LENGTH = 20;
export const OTP_MIN_LENGTH = 4;
export const PHONE_LENGTH = 11;
export const UNSUBSCRIBE_LENGTH = 80;
